import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SalesService } from '@shared/services/sales.service';
import { Utils } from '@shared/utils';
import { ChartModule } from 'primeng/chart';

@Component({
    standalone: true,
    selector: 'app-stats-widget',
    inputs: ['dateStart', 'dateEnd'],
    imports: [CommonModule,ChartModule],
    templateUrl:"./statswidget.html",
    styles: [`
        :host { width: 100%; }
  `]
})
export class StatsWidget {
    @Input() dateStart!: Date;
    @Input() dateEnd!: Date;
    
    isSalesLoading!:boolean
    todayStart!: Date;
    todayEnd!: Date;

    orderCountsPieData: any;
    itemCountsPieData: any;
    incomeListPieData: any;
    profitListPieData: any;

    orderCount: number = 0;
    itemCount: number = 0;
    income: number = 0;
    profit: number = 0;


    perItemProfit: number = 0;;
    perOrderProfit: number = 0;
    perItemIncome: number = 0;
    perOrderIncome: number = 0;

    orderCounts: number[] = [];
    itemCounts: number[] = [];
    incomeList: number[] = [];
    profitList: number[] = [];

    douhnutOptions: any = {
        plugins: {
            legend: false,
        }
    }

    constructor(private salesService: SalesService){}

    ngOnInit() {
        this.todayStart = this.dateStart || new Date(new Date().toDateString());
        this.todayEnd = this.dateEnd || new Date(this.todayStart.getTime() + (1000 * 60 * 60 * 24));
        this.getSalesFigure();
    }

    getSalesFigure() {
        this.isSalesLoading = true;

        this.salesService.getSalesFigureOnly(this.todayStart, this.todayEnd, false)
            .subscribe((records) => {
                this.isSalesLoading = false;
                this.prepairSumAndChartData(records);
                // this.topItems = record.topItems;

            });
    }
    prepairSumAndChartData(storefrontRecord: any[]) {
        
        this.orderCountsPieData = { labels: [], datasets: [{ data: [], backgroundColor: [], hoverBackgroundColor: [] }] };
        this.itemCountsPieData = { labels: [], datasets: [{ data: [], backgroundColor: [], hoverBackgroundColor: [] }] };
        this.incomeListPieData = { labels: [], datasets: [{ data: [], backgroundColor: [], hoverBackgroundColor: [] }] };
        this.profitListPieData = { labels: [], datasets: [{ data: [], backgroundColor: [], hoverBackgroundColor: [] }] };


        this.orderCount = 0; this.itemCount = 0; this.income = 0; this.profit = 0;
        this.orderCounts = []; this.itemCounts = []; this.incomeList = []; this.profitList = [];

        storefrontRecord.forEach(storeFrontData => {
            this.orderCount += storeFrontData.orders;
            this.itemCount += storeFrontData.quantity;
            this.income += storeFrontData.price;
            this.profit += storeFrontData.profit;

            this.orderCounts.push(storeFrontData.orders);

            const color = Utils.storeFrontColors[storeFrontData.storeFront as keyof typeof Utils.storeFrontColors] || '#000000'; // Default color

            this.orderCountsPieData.labels.push(storeFrontData.storeFront);
            this.orderCountsPieData.datasets[0].data.push(storeFrontData.orders);
            this.orderCountsPieData.datasets[0].backgroundColor.push(color);
            this.orderCountsPieData.datasets[0].hoverBackgroundColor.push(color);

            this.itemCountsPieData.labels.push(storeFrontData.storeFront);
            this.itemCountsPieData.datasets[0].data.push(storeFrontData.quantity);
            this.itemCountsPieData.datasets[0].backgroundColor.push(color);
            this.itemCountsPieData.datasets[0].hoverBackgroundColor.push(color);

            this.incomeListPieData.labels.push(storeFrontData.storeFront);
            this.incomeListPieData.datasets[0].data.push(storeFrontData.price);
            this.incomeListPieData.datasets[0].backgroundColor.push(color);
            this.incomeListPieData.datasets[0].hoverBackgroundColor.push(color);

            this.profitListPieData.labels.push(storeFrontData.storeFront);
            this.profitListPieData.datasets[0].data.push(storeFrontData.profit);
            this.profitListPieData.datasets[0].backgroundColor.push(color);
            this.profitListPieData.datasets[0].hoverBackgroundColor.push(color);

            this.itemCounts.push(storeFrontData.quantity);
            this.incomeList.push(storeFrontData.price);
            this.profitList.push(storeFrontData.profit);

        });
        if (this.itemCount > 0) {
            this.perItemProfit = this.profit / this.itemCount;
        }
        if (this.orderCount > 0) {
            this.perOrderProfit = this.profit / this.orderCount;
        }
        if (this.itemCount > 0) {
            this.perItemIncome = this.income / this.itemCount;
        }
        //perOrderIncome
        if (this.orderCount > 0) {
            this.perOrderIncome = this.income / this.orderCount;
        }
    }
}
